import { RealTimeServiceContext } from 'contexts/realTimeService';
import { useContext, useMemo } from 'react';
import type { TIssuedRewards } from '../helpers/rewardBonus';
import { getIssuedRewards } from '../helpers/rewardBonus';

export const useIssuedRewards = (): TIssuedRewards => {
  const { bonuses, freespins, lootboxes } = useContext(RealTimeServiceContext);

  return useMemo(
    () => getIssuedRewards([...bonuses, ...freespins, ...lootboxes]),
    [bonuses, freespins, lootboxes]
  );
};
